<div class="line-bar-chart-container">
    <div style="background-color:#f2f2f2;" class="bar-total">
        <span style="background-color: rgb(66, 132, 243); width: 33.3333%;" class="awayPercent bar-percentage"></span>
        10
    </div>
    <div style="background-color:#f2f2f2;" class="bar-total">
        <span style="background-color: rgb(244, 67, 54); width: 75%;" class="awayPercent bar-percentage"></span>
        20
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/line-bar-chart/line-bar-chart.html